import { useEffect, useRef } from 'react';

const BARS = 32;

export const VUMeter = ({ analyser, active, paused }) => {
  const canvasRef = useRef(null);
  const peakRef = useRef(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');
    let raf;
    const data = analyser ? new Uint8Array(analyser.fftSize) : null;

    const draw = () => {
      const { width, height } = canvas;
      ctx.clearRect(0, 0, width, height);

      let level = 0;
      if (analyser && active && !paused) {
        analyser.getByteTimeDomainData(data);
        let sum = 0;
        for (let i = 0; i < data.length; i += 1) {
          const v = (data[i] - 128) / 128;
          sum += v * v;
        }
        level = Math.min(1, Math.sqrt(sum / data.length) * 3.2);
      }
      peakRef.current = Math.max(level, peakRef.current * 0.92);

      const gap = 3;
      const barW = (width - gap * (BARS - 1)) / BARS;
      const lit = Math.round(level * BARS);
      const peakBar = Math.round(peakRef.current * BARS);

      for (let i = 0; i < BARS; i += 1) {
        const pct = i / BARS;
        let color = 'hsl(158 62% 30%)';
        if (pct > 0.85) color = 'hsl(0 72% 51%)';
        else if (pct > 0.65) color = 'hsl(38 92% 50%)';
        const isLit = i < lit || i === peakBar - 1;
        ctx.fillStyle = isLit ? color : 'rgba(120,120,120,0.18)';
        const h = height * (0.35 + 0.65 * ((i + 1) / BARS));
        ctx.beginPath();
        ctx.roundRect(i * (barW + gap), height - h, barW, h, 2);
        ctx.fill();
      }
      canvas.dataset.level = level.toFixed(2);
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [analyser, active, paused]);

  return (
    <div className="w-full max-w-sm" data-testid="vu-meter">
      <canvas ref={canvasRef} width={360} height={48} className="w-full h-12" data-testid="vu-meter-canvas" />
      <div className="flex justify-between text-[10px] uppercase tracking-wider text-muted-foreground mt-1">
        <span>Input level</span>
        <span>{!active ? 'Mic off' : paused ? 'Paused' : 'Live'}</span>
      </div>
    </div>
  );
};
